export class ReloadHelper {
	handleUpdateApp(): void {
		const url = new URL(window.location.href);
		const hashParam: string = 'updateHash';
		const hashValue = new Date().valueOf().toString();

		if (url.searchParams.has(hashParam)) {
			url.searchParams.set(hashParam, hashValue);
		} else {
			url.searchParams.append(hashParam, hashValue);
		}
		window.location.href = url.href;
	}
}

export const reloadHelper = new ReloadHelper();
